/**
 * Created by 1 on 2016/12/29.
 */
'use strict';
/**
 * 图层工厂类
 * @module LayerFactory
 */
define([],function(){
    /**
     * LayerFactory
     * @constructor
     * @classdesc 图层工厂
     * @alias G.lys.LayerFactory
     * @returns {Class} - 实例化的对象
     */
    var factory=function(map){
        this.map=map;
    };
    /**
     * 创建一张图图层
     * @method
     * @param {Number} type -必填，图层类型，枚举值参见G.lys.TYPES
     * @param {Object} options - 必填，图层参数
     * @returns {G.lys.BaseLayer} - 图层对象
     */
    factory.prototype.createLayer=function(type,options){
        var layer;
        var clazzObj=this._getClazzObj();
        var clazz=clazzObj[type];
        var opts=options||{};
        if(!opts.hasOwnProperty('map')){
            opts.map=this.map;
        }
        if(clazz){
            layer=new clazz(opts);
            layer.getLayer().layerGroups=opts.layerGroups||"add";
        }else{
            throw(new Error('未定义的图层类型！'+type));
        }
        return layer;
    }

    /**
     * 根据图层类名创建图层
     * @method
     * @param className {String} 必填，图层类名，如 G.lys.PointLayer/g2.lys.ElementLayer
     * @param options {Object} 必填，图层创建的参数，参数参考不同类型图层
     */
    factory.prototype.createLayerByClass=function(className,options){
        var regex,clazzName;
        if(className.indexOf('lys')!=-1){
            regex=/^((g2)|(G))\.lys\.(.*)$/,
                clazzName=className+'';
        }else{
            regex=/^((g2)|(G))\.carto\.(.*)$/,
                clazzName=className+'';
        }
        if(!regex.test(clazzName)){
            throw(new Error('错误的图层类名！'));
        }
        var matchArr=clazzName.match(regex);
        var clazz;
        if(className.indexOf('lys')!=-1){
            clazz=window[matchArr[1]]['lys'][matchArr[4]];
        }else{
            clazz=window[matchArr[1]]['carto'][matchArr[4]];
        }
        var opts=options||{};
        if(!opts.hasOwnProperty('map')){
            opts.map=this.map;
        }
        var layer=new clazz(opts);
        if(opts.attr){
            layer.attr=opts.attr;
        }
        //处理透明度、zIndex，visible等参数
        var keysMap={
            'opacity':'setOpacity',
            'visible':'setVisible',
            'zIndex':'setZIndex'
        }
        var thatLayer=(layer instanceof G.lys.BaseLayer)
            ?layer.getLayer():layer;
        for(var k in keysMap){
            if(options.hasOwnProperty(k)){
                if(thatLayer[keysMap[k]]){
                    thatLayer[keysMap[k]](options[k]);
                }
            }
        }
        return layer;
    }

    /**
     * @returns {{}|*}
     * @private
     */
    factory.prototype._getClazzObj=function(){
        if(!this._classObj){
            var clazzObj={};
            //分布图层
            clazzObj[G.lys.TYPES.ELEMENT_POINT_LAYER]=G.lys.PointLayer;
            clazzObj[G.lys.TYPES.FEATURE_POINT_LAYER]=G.lys.FeaturePointLayer;
            clazzObj[G.lys.TYPES.ELEMENT_POINT_PIXEL_CLUSTER]=G.lys.PointClusterLayer;
            clazzObj[G.lys.TYPES.ELEMENT_POINT_DUPLICATE]=G.lys.PointDuplicateLayer;
            clazzObj[G.lys.TYPES.ELEMENT_POLYLINE_LAYER]=G.lys.LineLayer;
            clazzObj[G.lys.TYPES.ELEMENT_POLYGON_LAYER]=G.lys.PolygonLayer;
            //统计图层
            clazzObj[G.lys.TYPES.PIE_STATISTICS_LAYER]=G.lys.PieStatisticsLayer;
            clazzObj[G.lys.TYPES.RING_STATISTICS_LAYER]=G.lys.RingStatisticsLayer;
            this._classObj=clazzObj;
        }
        return this._classObj;
    }
    return factory;
});
